import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import IconVerified from 'components/icons/iconVerified';
import getShortCustomerName from 'commons/getShortCustomerName';
import ReviewStars from 'components/consumer/ReviewStars';
import cleanComment from 'commons/cleanComment';
import useScreen from 'hooks/useScreen';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
const ReviewComponent = t0 => {
  const $ = _c(45);
  const {
    collapsible: t1,
    date,
    full_name,
    keyId,
    location,
    maxWords: t2,
    rate,
    review
  } = t0;
  const collapsible = t1 === undefined ? false : t1;
  const maxWords = t2 === undefined ? 40 : t2;
  const splittedReview = review.split(" ");
  const [isCollapsed, setIsCollapsed] = useState(!!(collapsible && splittedReview.length > maxWords));
  const {
    isMobileOrTablet
  } = useScreen();
  if (!review) {
    return null;
  }
  const reviewToShow = isCollapsed ? `${splittedReview.slice(0, maxWords).join(" ")}...` : review;
  const t3 = `r${keyId}`;
  const t4 = parseInt(rate, 10);
  let t5;
  if ($[0] !== t4) {
    t5 = <ReviewStars rating={t4} readOnly={true} size="sm" />;
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== t3 || $[3] !== t5) {
    t6 = <div key={t3} className="[&_svg]:relative [&_svg]:top-0.5 [&_svg]:max-[767px]:w-2.5 [&_span]:mr-[.3rem]">{t5}</div>;
    $[2] = t3;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const rating = t6;
  let t7;
  if ($[5] !== full_name?.[0] || $[6] !== isMobileOrTablet || $[7] !== rating) {
    t7 = isMobileOrTablet ? rating : <div className="w-11 h-11 max-h-[3.75rem] text-2xl text-gray-light6 bg-gray-light8 rounded-full mr-4 mb-2 flex justify-center items-center">{full_name?.[0]}</div>;
    $[5] = full_name?.[0];
    $[6] = isMobileOrTablet;
    $[7] = rating;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== full_name) {
    t8 = getShortCustomerName(full_name);
    $[9] = full_name;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconVerified />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8) {
    t10 = <div className="[&_svg]:ml-2 [&_svg_g]:stroke-[#107c8c] flex items-center justify-start"><h4 className="text-sm font-bold m-0">{t8} {t9}</h4></div>;
    $[12] = t8;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== location) {
    t11 = <div className="text-xs">{location}</div>;
    $[14] = location;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11) {
    t12 = <div className="PDPFabricReviewsUI__user-details">{t10}{t11}</div>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t7) {
    t13 = <div className="flex-[0.28] max-[767px]:flex max-[767px]:flex-1 max-[767px]:flex-col max-[767px]:mb-4">{t7}{t12}</div>;
    $[19] = t12;
    $[20] = t7;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== isMobileOrTablet || $[23] !== rating) {
    t14 = !isMobileOrTablet && <div className="flex justify-between mb-4">{rating}</div>;
    $[22] = isMobileOrTablet;
    $[23] = rating;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== date) {
    t15 = format(new Date(date), "MMM dd, yyyy");
    $[25] = date;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <div className="text-xs absolute top-1 right-0 max-[767px]:text-xs max-[767px]:-top-8">{t15}</div>;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== reviewToShow) {
    t17 = cleanComment(reviewToShow);
    $[29] = reviewToShow;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17) {
    t18 = <SanitizedHtml className="text-xs" html={t17} />;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== isCollapsed || $[34] !== setIsCollapsed) {
    t19 = isCollapsed && <span className="text-xs text-brand cursor-pointer hover:underline" onClick={() => setIsCollapsed(false)}>Continue Reading</span>;
    $[33] = isCollapsed;
    $[34] = setIsCollapsed;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t14 || $[37] !== t16 || $[38] !== t18 || $[39] !== t19) {
    t20 = <div className="relative md:flex-[0.72]">{t14}{t16}{t18}{t19}</div>;
    $[36] = t14;
    $[37] = t16;
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== keyId || $[42] !== t13 || $[43] !== t20) {
    t21 = <div key={keyId} className="flex px-0 py-6 [border-bottom:1px_solid_#f1f1f1] max-[767px]:flex-col">{t13}{t20}</div>;
    $[41] = keyId;
    $[42] = t13;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  return t21;
};
ReviewComponent.propTypes = {
  collapsible: PropTypes.bool,
  date: PropTypes.string,
  full_name: PropTypes.string,
  keyId: PropTypes.string,
  location: PropTypes.string,
  maxWords: PropTypes.number,
  rate: PropTypes.number,
  review: PropTypes.string
};
export default ReviewComponent;